export default [
  {
    path: 'welcome-450',
    name: 'welcome-450',
    component: () => import('pages/landingPages/Welcome450/index.vue'),
  },
  {
    path: 'welcome-bonus/:currency?',
    name: 'welcome-bonus',
    component: () => import('pages/landingPages/WelcomeBonus.vue'),
  },
  {
    path: 'aviator',
    name: 'aviator',
    component: () => import('pages/landingPages/Aviator.vue'),
  },
  {
    path: 'gates_of_olympus/:currency?',
    name: 'gates_of_olympus',
    component: () => import('pages/landingPages/GatesOfOlympus.vue'),
  },
  {
    path: 'golden_times_kz',
    name: 'golden_times_kz',
    component: () => import('pages/landingPages/GoldenTimesKz.vue'),
  },
  {
    path: 'fruity_wheel',
    children: [
      {
        path: 'money/:currency?',
        name: 'fruity_wheel_money',
        component: () => import('pages/landingPages/FruityWheel.vue'),
      },
      {
        path: ':currency?',
        name: 'fruity_wheel',
        component: () => import('pages/landingPages/FruityWheel.vue'),
      },
    ],
  },
  {
    path: 'sweet_wheel/:currency?',
    name: 'sweet_wheel',
    component: () => import('pages/landingPages/SweetWheel.vue'),
  },
  {
    path: 'sport',
    name: 'sport',
    component: () => import('pages/landingPages/Sport.vue'),
  },
]
